import React, { useEffect } from "react";
import Paper from "@mui/material/Box";
import { useDispatch } from "react-redux";
import { Admin, Organization } from "../../../../models";
import LinearProgress from "@mui/material/LinearProgress";
import { useSearchParams } from "react-router-dom";
import { from } from "rxjs";
import medAppApi from "../../../../api/medAppApi";
import { putMessage } from "../../../app/store/actions";
import AddOrganization from "./add-organization-form";

const OrganizationCreate: React.FC<{
  organization?: Organization;
}> = ({ organization }) => {
  let [searchParams] = useSearchParams();

  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [admin, setAdmin] = React.useState<Admin | undefined>();

  useEffect(() => {
    console.log(searchParams);
    const adminId = parseInt(searchParams.get("admin") || "NaN", 10);
    if (!adminId || isNaN(adminId)) {
      return;
    }

    const resp$ = from(
      medAppApi.viewModel<Admin>({ modelId: adminId, modelName: "admin" })
    );
    resp$.subscribe({
      next: (res) => {
        if (res.code !== 200) {
          dispatch(
            putMessage({ message: "Something went wrong", type: "error" })
          );
          return;
        }

        setAdmin(res.data?.data?.payload);
      },
      complete() {
        setLoading(false);
      },
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  return (
    <Paper
      style={{
        width: "100%",
      }}
    >
      {loading && <LinearProgress />}
      {admin && <AddOrganization admin={admin} />}
    </Paper>
  );
};

export default OrganizationCreate;
